import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pin: { x:0, y:0 },
    longitude: -118.39,
    latitude: 34.12,
    medianHouseValue: 0
  },
  mutations: {
    SET_PIN(state, value) {
      state.pin.x = value.x;
      state.pin.y = value.y;
    },
    SET_LONGITUDE(state, value) {
      state.longitude = value;
    },
    SET_LATITUDE(state, value) {
      state.latitude = value;
    },
    SET_MEDIAN_HOUSE_VALUE(state, value) {
      state.medianHouseValue = value;
    }
  },
  actions: {},
  modules: {}
});
